<template>
    <div class="searchBox">
        <div class="tag_box">
            <div class="tag_item">
                <a-checkbox-group v-model="types">
                    <a-checkbox value="click" name="click">
                    点击事件
                    </a-checkbox>
                    <a-checkbox value="api" name="api">
                    接口请求
                    </a-checkbox>
                    <a-checkbox value="resource" name="resource">
                    资源加载
                    </a-checkbox>
                    <a-checkbox value="js-error" name="js-error">
                    js异常
                    </a-checkbox>
                    <a-checkbox value="business-point" name="business-point">
                    业务埋点
                    </a-checkbox>
                </a-checkbox-group>
            </div>

        </div>

        <a-spin :spinning="chartloading">
            <a-timeline mode="alternate">
                <a-timeline-item v-for="item in logs" :key="item.log_time" :color="colors[item.log_type]"
                    :position="item.log_type == 'pv' ? 'right' : 'left'">
                    <a-button type="link" @click="handleViewLog(item)">
                        <span :style="{color:colors[item.log_type]}">{{item.log_time}}</span>
                        <!-- <span style="color:#1890ff;padding-left:20px;"></span> -->
                        <a-icon style="color:#1890ff;padding-left:4px;" type="file-search" />
                    </a-button>
                    <div class="line_left" v-if="item.log_type == 'pv'">
                        <p>{{'' + item.url_path}}</p>
                        <p>{{ '加载耗时：' + (item.pv_loadtime != 'null' ?  ((parseInt( item.pv_loadtime) / 1000).toFixed(3) + 's') : 'null')}}
                        </p>
                        <p>{{'用户信息：' + item.user_sign}}</p>
                    </div>
                    <div class="line" v-if="item.log_type == 'click'" v-show="types.indexOf(item.log_type) != -1">
                        <p>{{ '点击："' + item.ck_el_content + '"' + '  元素类型：' + item.ck_el_type}}</p>
                    </div>
                    <div class="line" v-if="item.log_type == 'api'" v-show="types.indexOf(item.log_type) != -1">
                        <p>{{ '接口地址：' + item.res_url}} <a-button type="link" @click="handleRelation(item)">调用链路
                            </a-button>
                        </p>
                        <p>{{ '请求耗时：' + (parseInt(item.res_duration) / 1000).toFixed(3) + 's'}}</p>
                    </div>
                    <div class="line" v-if="item.log_type == 'resource'">
                        <p>{{ '资源地址：' + item.res_url}}</p>
                        <p>{{ '耗时：' + (parseInt(item.res_duration) / 1000).toFixed(3) + 's'}}</p>
                    </div>
                    <div class="line" v-if="item.log_type == 'js-error'">
                        <p>{{ '错误类型：' + item.js_err_name}}</p>
                        <p>{{ '错误消息：' + item.js_err_msg.slice(0,20) + '...'}}</p>
                    </div>
                    <div class="line" v-if="item.log_type == 'business-point'">
                        <p>{{ '事件名称：' + item.eventname}}</p>
                        <p>{{ 'business：' + item.business.slice(0,20) + '...'}}</p>
                    </div>
                </a-timeline-item>
            </a-timeline>
        </a-spin>
        <logViewer ref="myViewer"></logViewer>

        <div class="timeline_filter_box">
            <a-pagination  class="pageer" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper show-size-changer @showSizeChange="onShowSizeChange" />
        </div>
    </div>
</template>

<script>

import logViewer from '../components/logviewer'

let pagenation ={
    current:1,
    pageSize:10,
    total:0
};
export default {
    components:{
        logViewer
    },
    data() {
        return {
            chartloading:false,
            logs:[],
            colors:{
                pv:'#52c41a',
                click:'#faad14',
                api:'#1890ff',
                resource:'#a26ef4',
                'js-error':'#f5222d',
                'business-point':'#e4249b'
            },
            pagenation,
            searchP:{},
            types:[
                'click',
                'api',
                'resource',
                'js-error',
                'business-point'
            ]
        };
    },
    methods: {
        handleRelation(item){
            //链路上下十分钟时间
            let timePoint = item.log_time;
            let starttime = new Date(timePoint).getTime() - 10 * 60000;
            let endtime = new Date(timePoint).getTime() + 10 * 60000;
            let routeResolve =this.$router.resolve({
                path:"/monitorservice/relation",
                query:{
                    traceid:item.res_traceid,
                    url:item.res_url,
                    starttime:starttime,
                    endtime:endtime
                }
            })
            window.open(routeResolve.href, '_blank');
        },
        onShowSizeChange(current, pageSize) {
            this.pagenation.current = 1;
            this.pagenation.pageSize = pageSize;
            this.getUserLogs();
        },
        handlePageChange(v){
            this.pagenation.current = v
            this.getUserLogs();
        },
        handleViewLog(item){
            this.$refs.myViewer.loadData(item)
        },
        getUserLogs(searchP){
            if(!searchP){
                searchP = this.searchP
            }
            else{
                this.searchP = searchP
                this.pagenation.current = 1;
            }
            console.log(searchP)
            let that = this;
            let timeRange = searchP.selectedTimeRange;
            timeRange = timeRange.split('~');
            let starttime = (new Date(timeRange[0]).getTime())/1000;
            let endtime = (new Date(timeRange[1]).getTime())/1000;
            let queryStr = "* | select * from log  where project_name = '"+searchP.sleectedSys+"' and session_id='"+searchP.session_id+"' order by log_time asc";
            that.chartloading = true;
            let params = {
                projectname:'fp-zl-device',
                logstorename:searchP.selectedEnv,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.logs = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        }
    },
    mounted(){
    }
};
</script>

<style lang="less" scoped>
    .line{
        width:300px;
        position: relative;
    }
    .line_left{
        text-align: right;
    }
    .timeline_filter_box{
        display: inline-flex;
        width: 100%;
        height: 80px;
    }
    .timeline_filter_box .pageer{
        display: block;
        margin: 0 auto;
    }

    .tag_box{
        display: inline-flex;
        width: 100%;
        margin-bottom: 30px;
    }

    .tag_box .tag_item{
        display: block;
        margin: 0 auto;
    }


</style>